import { observer } from "mobx-react-lite";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
import reportData from "./reportSLNS.json";
import "react-pivottable/pivottable.css";
import TableRenderers from "react-pivottable/TableRenderers";
import { useState } from "react";
import "./pivot.css";
import SettingsIcon from "@mui/icons-material/Settings";
import CancelIcon from '@mui/icons-material/Cancel';

let dataConvert = reportData.map((item) => {
  return {
    "Tổ sản xuất": item.TSX,
    "MVNV - Tên": item.MSSV_Ten,
    "Số lượng CT KH": item.SLCTKH,
    "Số lượng CT TT": item.SLCTTT,
    "% HT": item.PERHT,
    "SP KH": item.SPKH,
    "SP TT": item.SPTT,
    "% NS": item.PERNS,
  };
});

export function createPivotTable() {
  return observer(() => {
    const [state, setState] = useState({});
    const [openSetting, setOpenSetting] = useState(false);
    const handleonSettingClick = () => {
      setOpenSetting(!openSetting);
    };

    return (
      <div className="w-full  py-3 px-2 bg-white">
        <div className="title text-center ">
          <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
            <u className="text-blue-600">PIVOT TABLE </u>: Báo cáo sản lượng &
            năng suất theo tổ / công nhân
          </h3>
        </div>

        <div className={`pivotContainer bg-white ${openSetting?'pivotHandleOpen':'pivotHandleClose'}  `}>
          <span onClick={handleonSettingClick}>
            {openSetting ? <CancelIcon/> : <SettingsIcon />}
          </span>
          <PivotTableUI
            data={dataConvert}
            rows={["Tổ sản xuất", "MVNV - Tên"]}
            cols={["SP KH","SP TT"]}
            {...state}
            onChange={(s: any) => {
              setState(s);
            }}
            renderers={Object.assign({}, TableRenderers)}
          />
        </div>
      </div>
    );
  });
}
